import { BaseService } from "./BaseService";
import { CommandService } from "./CommandService";
import { Configuration } from "Configuration";
import { MappingDefinition, GridDefinitionClient, BaseGridDefinition, MappingDisplayTypes } from "./Client";
import CancellationToken from "cancellationtoken";

/**
 * Service for requesting gridDefinitions.
 * @hidden
 */
export class GridDefinitionService extends BaseService {
    /**
     * Get all gridDefinitions for a given mapping.
     * @param mappingName Name of the mapping.
     * @param displayType MappingDisplayType.
     */
    public getMapping(
        mappingName: string,
        displayType: MappingDisplayTypes = MappingDisplayTypes.FilterAndGrids,
        token: CancellationToken
    ): Promise<MappingDefinition> {
        let param = CommandService.getContextParameters();
        let client = new GridDefinitionClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return this.handleResult(
            new Promise<MappingDefinition>((resolve, reject) => {
                const xhr = client.getAll(
                    mappingName,
                    displayType,
                    param,
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );

                if (token) {
                    token.onCancelled((reason) => {
                        xhr.abort();
                        reject(reason);
                    });
                }
            })
        );
    }

    /**
     * Get a single gridDefinition by gridId.
     * @param gridId GridID.
     */
    public getGrid(mappingName: string, gridId: number): Promise<BaseGridDefinition> {
        let param = CommandService.getRequestParameters();
        let client = new GridDefinitionClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return this.handleResult(
            new Promise<BaseGridDefinition>((resolve, reject) => {
                client.getSingle(
                    mappingName,
                    gridId,
                    param,
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );
                // cancellationTokenSource.token.onCancelled((reason) => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }
}
